import React from "react"
import { Grid, Col, View, Text, SegmentedControl } from "react-ame-components"

export class SegmentedControlExample extends React.Component {
  state = {
    tabIndex: 0,
    tabs: [
      {
        title: "Anual",
        valor: "R$ [b][color=primary]75,90[/color][/b]",
      },
      {
        title: "Semestral",
        valor: "R$ [b][color=primary]89,90[/color][/b]",
      },
      {
        title: "Mensal",
        valor: "R$ [b][color=primary]109,90[/color][/b]",
      },
    ],
  }

  handleTabChange = index => {
    this.setState({ tabIndex: index })
  }

  render() {
    return (
      <View
        direction="column"
        align="center"
        justify="center"
        marginTop="big">
        <Grid>
          <Col columnSize={{ sm: 1, md: 3 }}></Col>
          <Col columnSize={{ sm: 10, md: 6 }}>
            <View
              backgroundColor="neutral-100"
              padding="big"
              borderRadius="small"
              shadow="level-2"
              direction="column"
              align="center">
              <Text
                fontSize="large"
                lineHeight="large"
                fontWeight="bold">
                Componente [color=primary]SegmentedControl[/color]
              </Text>
              <Text>
                Este componente serve para criar abas navegáveis. Veja abaixo:
              </Text>
              <View
                margin="large"
                width="auto">
                <SegmentedControl
                  activeTab={this.state.tabIndex}
                  onChange={this.handleTabChange}
                  items={[
                    { title: this.state.tabs[0].title },
                    { title: this.state.tabs[1].title },
                    { title: this.state.tabs[2].title },
                  ]}
                />
                <View
                  width="312px"
                  backgroundColor="neutral-300"
                  paddingBottom="big"
                  paddingTop="big"
                  borderRadius="small"
                  borderWidth="thin"
                  borderTopWidth="none"
                  borderColor="primary-700"
                  justify="center">
                  <Text
                    textAlign="center"
                    fontSize="large">
                    {this.state.tabs[this.state.tabIndex].valor}
                    <Text fontSize="nano">/Mês</Text>
                  </Text>
                </View>
              </View>
            </View>
          </Col>
          <Col columnSize={{ sm: 1, md: 3 }}></Col>
        </Grid>
      </View>
    )
  }
}
